module.exports = __webpack_public_path__ + "static/img/6.cc3e408.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/eng/6.png
// module id = Swae
// module chunks = 0